import { PropTypes } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { placements, Tooltip } from '@ge/components/tooltip';
import { Placeholders } from '@ge/models/constants';
import { elevations } from '@ge/tokens/elevations';

const MessageContainer = styled.div`
  text-transform: uppercase;
  max-width: 1000px;
  text-overflow: ellipsis;
  overflow: hidden;
  .command {
    font-weight: 700;
  }
`;

const formatCommandDescription = (desc) => {
  if (!desc || typeof desc !== 'string') {
    return '';
  }

  try {
    const parsedDesc = JSON.parse(desc);
    const { txt, details = [] } = parsedDesc || {};

    if (!txt || typeof txt !== 'string') {
      return desc;
    }

    let detailIndex = 0;

    return txt.replace(/\?/g, () => {
      const replacementValue = details[detailIndex];
      detailIndex += 1;
      return replacementValue ?? '?';
    });
  } catch (error) {
    return desc;
  }
};

export const CommandMessage = ({ command, status, desc }) => {
  const { ready, t } = useTranslation(['monitor.assets'], { useSuspense: false });
  const formattedDesc = formatCommandDescription(desc);

  if (!ready) {
    return Placeholders.DOUBLE_DASH;
  }

  return (
    <MessageContainer>
      <span className="command">{t(`notification.${command}`, 'Command')}</span>{' '}
      {t(`notification.${status}`)}
      {'      '}
      {formattedDesc ? (
        <Tooltip
          title={formattedDesc}
          className="tooltip-cmdNotif"
          zIndex={elevations.P20}
          placement={placements.TOP}
        >
          <span>
            {t('notification.error_desc', ' Error Desc: ')}
            {formattedDesc}
          </span>
        </Tooltip>
      ) : (
        ''
      )}
    </MessageContainer>
  );
};

CommandMessage.propTypes = {
  command: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
};
